import { ActionTree } from 'vuex';
import HttpService from '@/plugins/http-service';
import IRootState from '@/store/types/IRootState';
import CmsState from './types/CmsState';

const actions: ActionTree<CmsState, IRootState> = {
  load(context, { url, type }) {
    HttpService
      .get(url, {
        responseType: 'json',
      })
      .then((response: any) => {
        if (response.status === 200) {
          context.commit(type, response.data);
        }
      })
      .catch((error: Error) => {
        // tslint:disable-next-line:no-console
        console.log(error);
      });
  },
};

export default actions;
